import {createSelector} from 'reselect';

/* istanbul ignore next */
const errorsSelector = createSelector((state, props) => state.errors || {errors: []}.errors, (errors) => errors || []);
/* istanbul ignore next */
const msgsSelector = createSelector((state, props) => state.msgs || {msgs: []}.msgs, (msgs) => msgs || []);

export let reducers = {};

export function mapStateToProps(state) {
  return {
    errors: errorsSelector(state),
    msgs: msgsSelector(state)
  };
}

export function handleError(error, actionType) {
  return (dispatch, getState) => {
    dispatch({type: actionType || 'ADD_ERROR', error});
  };
}

export function handleSuccess(msg) {
  return (dispatch, getState) => {
    dispatch({type: 'ADD_SUCCESS', msg});
  };
}

export function onCloseError(index) {
  return (dispatch) => {
    dispatch({type: 'REMOVE_ERROR', index});
  };
}

export function onCloseSuccess(index) {
  return (dispatch) => {
    dispatch({type: 'REMOVE_SUCCESS', index});
  };
}

export function mapDispatchToProps(dispatch, getState) {
  return {
    handleSuccess: (msg) => handleSuccess(msg)(dispatch, getState),
    handleError: (error, actionType) => handleError(error, actionType)(dispatch, getState),
    onCloseError: (index) => onCloseError(index)(dispatch),
    onCloseSuccess: (index) => onCloseSuccess(index)(dispatch)
  };
}

reducers.ADD_ERROR = (state, action) => {
  return {...state, errors: [...errorsSelector(state), action.error]};
};

reducers.ADD_SUCCESS = (state, action) => {
  return {...state, msgs: [...msgsSelector(state), action.msg]};
};

reducers.REMOVE_ERROR = (state, action) => {
  return {...state, errors: state.errors.filter((error, i) => i !== action.index)};
};

reducers.REMOVE_SUCCESS = (state, action) => {
  return {...state, msgs: state.msgs.filter((msg, i) => i !== action.index)};
};
